// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Button from "elevate-ui/Button";
import { withGlobalContext } from "../common/GlobalContext";
import Details from "../listing-detail/Details";
import type { CompliantListingType } from "flow/types";

type Props = {
  classes: Object,
  className: string,
  listing: CompliantListingType,
  videoUrl: string,
};

const BlogVideo = ({ classes, className, videoUrl, listing }: Props) => {
  if (!listing) {
    return (
      <div className={classNames(classes.root, className)}>
        Sorry, the selected listing could not be found.
      </div>
    );
  }

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.videoWrapper}>
        <iframe
          title="virtualTour"
          src={videoUrl}
          frameBorder="0"
          allowFullScreen
          className={classes.video}
        />
      </div>

      <Details
        classes={{ publicRemarks: classes.publicRemarks }}
        listing={listing}
      />
      <Button
        element="a"
        href={
          listing.detailUrl
            ? listing.detailUrl
            : `/listings/${listing.detailsUrlSlug}`
        }
        style={{ marginTop: "48px" }}
      >
        Learn more about this property
      </Button>
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  videoWrapper: {
    position: "relative",
    paddingBottom: "56.25%",
    height: 0,
    width: "100%",
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  publicRemarks: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "700px",
    color: theme.colors.gray["900"],
    fontSize: "16px",
    lineHeight: "1.6",
    paddingTop: theme.spacing.unit,
  },
}))(withGlobalContext(BlogVideo));
